export enum CompanyRegistrationStep{
    /**
     * Sua companhia
     */
    CompanyData,

    /**
     * Seu endereço
     */
    Address,

    /**
     * Estrutura societária
     */
    Partners,

    /**
     * Seu banco
     */
    BankData,

    /**
     * Seu patrimônio
     */
    Patrimony,

    /**
     * Empresas coligadas
     */
    RelatedEnterprises,

    /**
     * Emissores
     */
    Emitters
}